export const pathName = {
    home: "/",

    CompanyCustomers: "/company/customers",

    customersContractPage: "/customers/contracts",
    customersDevicesPage: "customers/devices",
    customersSupport: "/customers/support",

    fulfillmentContractsPage: "/fulfillment/contracts",
    fulfillmentPoliciesPage: "/fulfillment/policies",
    fulfillmentSupportPage: "/fulfillment/support",
    fulfillmentCustomersPage: "/fulfillment/customers",

    customersProfilePage(companyId = ":companySlug", customerId=":customerSlug")
    {
        return `/fulfillment/customers/${companyId}/${customerId}`
    },
};
